import Main from "../components/application-incompletion-reason-register/Main";
import { PERMISSIONS, USER_TYPE } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/**
 * 申請不備理由登録.
 */
const ApplicationIncompletionReasonRegister = () => {
  const authed = useAuthenticationHook(PERMISSIONS.APPLY, USER_TYPE.DOCOMO);

  return <>{authed && <Main />}</>;
};

export default ApplicationIncompletionReasonRegister;
